import React, { useState, useEffect, useRef } from 'react';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useToast } from './Toast';

function SuggestVehicleModal({ dominio, onClose }) {
  const [vehicleData, setVehicleData] = useState({
    marca: '', interno: '', empresa: '', proyectoMinero: '', otros: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const modalRef = useRef(null);
  const toast = useToast();

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleEscape);
    modalRef.current?.focus();
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVehicleData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const functions = getFunctions();
      const sugerirVehiculo = httpsCallable(functions, 'sugerirVehiculo');
      const result = await sugerirVehiculo({ dominio, ...vehicleData });

      if (result.data.success) {
        toast.success("Sugerencia enviada con éxito. Gracias.");
        setTimeout(onClose, 1500);
      } else {
        throw new Error(result.data.message);
      }
    } catch (error) {
      console.error("Error al enviar sugerencia:", error);
      toast.error("Error al enviar. Intentá de nuevo.");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="suggest-title"
        ref={modalRef}
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id="suggest-title">Sugerir Nuevo Vehículo</h2>
        </div>
        <div className="modal-body">
          <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-md)' }}>
            El dominio <strong>{dominio}</strong> no se encontró. Podés sugerir su alta:
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="sug-marca" className="form-label">Marca</label>
              <input id="sug-marca" name="marca" className="form-input" value={vehicleData.marca} onChange={handleInputChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="sug-interno" className="form-label">N° Interno</label>
              <input id="sug-interno" name="interno" className="form-input" value={vehicleData.interno} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="sug-empresa" className="form-label">Empresa</label>
              <input id="sug-empresa" name="empresa" className="form-input" value={vehicleData.empresa} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="sug-proyecto" className="form-label">Proyecto Minero</label>
              <input id="sug-proyecto" name="proyectoMinero" className="form-input" value={vehicleData.proyectoMinero} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="sug-otros" className="form-label">Comentarios</label>
              <textarea id="sug-otros" name="otros" className="form-input" value={vehicleData.otros} onChange={handleInputChange} rows="2" />
            </div>
            <div className="modal-footer" style={{ padding: 0 }}>
              <button type="button" onClick={onClose} disabled={isSubmitting} className="btn btn-outline">Cancelar</button>
              <button type="submit" disabled={isSubmitting} className="btn btn-success">
                {isSubmitting ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SuggestVehicleModal;
